import React from "react";
import { connect } from "react-redux";
import { compose, lifecycle } from "recompose";
import { withRouter } from "react-router-dom";

import Card from "react-md/lib/Cards/Card";
import CardText from "react-md/lib/Cards/CardText";
import Button from "react-md/lib/Buttons/Button";

import Header from "../components/HostServerOrgHeader";
import Info from "../components/resource/Info";
import Table from "../components/resource/Table";
import AddRightsForm from "../components/resource/AddRightsForm";

import { setActiveForm } from "../actions/appActions";
import {
  getResourcesForAdmin,
  getUserResourcesRights
} from "../actions/resourceActions";

import { setDialog } from "../actions/dialogActions";
import {TouchPageHeader, TouchPageHeader_and_content_spaceBetween} from "../AtollonTheme/ReactElements";

const Resource = ({
  history,
  resource,
  setActiveForm,
  activeForm,
  setDialog,
  rights
}) => {
  if (!resource) return <div />;
  return (
    <div className="flex-col">

        <TouchPageHeader
            title={`Zdroj - ${resource.clientId}`}
            buttons={(
                <Button
                    raised
                    className="btn btn-primary"
                    label="Odstranit zdroj"
                    onClick={() => {
                        setDialog("AdminResourcesRemoveResource", { id: resource.id })}
                    }
                >delete</Button>

            )}
        />
        <TouchPageHeader_and_content_spaceBetween heightPx={50}/>

      {/*
      <Header
        title=""
        onDeleteAction={() =>
          setDialog("AdminResourcesRemoveResource", { id: resource.id })}
      />
      */}
      <div className="margin-bottom">
        <Info initialValues={resource} />
      </div>
      <Card>
        <CardText>
          <div className="margin-bottom-small">
            <Table rights={rights} />
          </div>
          {activeForm === "adminResourcesAddUserResourceRightsForm" ? (
            <AddRightsForm resource={resource} />
          ) : (
            <Button
              icon
              onClick={() =>
                setActiveForm("adminResourcesAddUserResourceRightsForm")}
            >
              add
            </Button>
          )}
        </CardText>
      </Card>
    </div>
  );
};

export default compose(
  withRouter,
  connect(
    ({ app: { form: { activeForm } }, resource: { resource, rights } }) => ({
      activeForm,
      resource,
      rights
    }),
    {
      getResourcesForAdmin,
      getUserResourcesRights,
      setActiveForm,
      setDialog
    }
  ),
  lifecycle({
    componentWillMount() {
      const {
        getResourcesForAdmin,
        match,
        getUserResourcesRights
      } = this.props;

      getResourcesForAdmin(match.params.id);
      getUserResourcesRights(match.params.id);
    }
  })
)(Resource);



// WEBPACK FOOTER //
// ./src/pages/Resource.js